import { render, staticRenderFns } from "./ImageTitleDescription.vue?vue&type=template&id=81978130&scoped=true"
import script from "./ImageTitleDescription.vue?vue&type=script&lang=js"
export * from "./ImageTitleDescription.vue?vue&type=script&lang=js"
import style0 from "./ImageTitleDescription.vue?vue&type=style&index=0&id=81978130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81978130",
  null
  
)

export default component.exports